var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"historial-container"},[(_vm.screenWidth > 800)?_c('div',[_c('HistorialPaymentTable',{on:{"changeTab":(tabToChange) => _vm.changeTab(tabToChange)}})],1):_c('div',[_c('HistorialPaymentResponsive',{on:{"changeTab":(tabToChange) => _vm.changeTab(tabToChange)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }